/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsIntegratedToolProvider {
    getFixupPrototypeFunction() { return FilterOptionsIntegratedToolProvider.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsIntegratedToolProvider>): FilterOptionsIntegratedToolProvider {
        let obj = Object.assign(new FilterOptionsIntegratedToolProvider(), model);
        FilterOptionsIntegratedToolProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsIntegratedToolProvider>): FilterOptionsIntegratedToolProvider {
        if (!model) return null;
        return FilterOptionsIntegratedToolProvider.newInstance(<FilterOptionsIntegratedToolProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsIntegratedToolProvider) {
        if (!obj) return;

        models.FilterOptionsIntegratedToolProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsIntegratedToolProvider): boolean {
        Object.setPrototypeOf(obj, FilterOptionsIntegratedToolProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tool_accounts) {
            for (let val of this.tool_accounts) {
                models.FilterOptionsIntegratedToolAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Integrated Tool for the account
     */
    tool: models.IntegratedToolName;

    /**
     * List of accounts for this Integrated Tool Provider
     */
    tool_accounts: Array<models.FilterOptionsIntegratedToolAccount>;

}
